import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
  InfoNote,
} from "@/components/help/help-ui";

const tips = () => [
  i18n.t("help.safe.items.public"),
  i18n.t("help.safe.items.instincts"),
  i18n.t("help.safe.items.private"),
  i18n.t("help.safe.items.short"),
  i18n.t("help.safe.items.tell"),
  i18n.t("help.safe.items.block"),
  i18n.t("help.safe.items.owe"),
];

export default function StayingSafe() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.safe.title")}>
      <HelpIntro>{i18n.t("help.safe.intro")}</HelpIntro>

      <HelpSection heading={i18n.t("help.safe.tips")} bullets={tips()} />

      <InfoNote icon="alert-circle-outline">
        {i18n.t("help.safe.emergency")}
      </InfoNote>

      <HelpButton
        label={i18n.t("help.safe.report")}
        icon="shield-outline"
        variant="danger"
        onPress={() => router.push("/help/contact?source=safety")}
      />
    </HelpScreen>
  );
}
